import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Homepage from "./pages/index";
import AppointmentID from "./pages/appointment";
import PatientID from "./pages/patient";
import PatientProfileEdit from "./pages/patient/edit";
import Patients from "./pages/patient/patients";
import WorkerID from "./pages/worker";
import Login from "./pages/auth/login";
import ForgotPassword from "./pages/auth/forgot-password";
import ResetPassword from "./pages/auth/reset-password";
import Register from "./pages/auth/register";
import RegisterPatient from "./pages/patient/register-patient";
import Data from "./pages/auth/register/bio-data";
import Data2 from "./pages/auth/register/bio-data2";
import Kin from "./pages/auth/register/next-of-kin";
import Profile from "./pages/profile";
import Dashboard from "./pages/dashboard";
import Admin from "./pages/dashboard/admin";
import Password from "./pages/dashboard/password";
import Appointment from "./pages/appointment/appointments";
import MyActivity from "./pages/activity";
import Chat from "./pages/chat";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Homepage />} />
      <Route path="/dashboard" element={<Dashboard />} />

      <Route path="/appointments" element={<Appointment />} />
      <Route path="/appointment/:id" element={<AppointmentID />} />
      <Route path="/worker/:id" element={<WorkerID />} />
      <Route path="/patient/:id" element={<PatientID />} />
      <Route path="/patient/edit/:id" element={<PatientProfileEdit />} />
      <Route path="/patients" element={<Patients />} />
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/reset-password" element={<ResetPassword />} />
      <Route path="/auth/register" element={<Register />} />
      <Route path="/patient/register-patient" element={<RegisterPatient />} />
      <Route path="/auth/register/bio-data" element={<Data />} />
      <Route path="/auth/register/bio-data2" element={<Data2 />} />
      <Route path="/auth/register/next-of-kin" element={<Kin />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/my-activity" element={<MyActivity />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/dashboard/admin" element={<Admin />} />
      <Route path="/dashboard/password" element={<Password />} />
    </Route>,
  ),
);

export default router;
